<template>
  <div
    class="kye-report-echarts-legend-more"
    :style="legendMoreStyle"
  >
    <el-popover
      v-if="legendMoreMap.poppverProps"
      @show="showPoppver(1)"
      @hide="showPoppver(0)"
      placement="bottom"
      :width="legendMoreMap.poppverProps.width"
      :trigger="legendMoreMap.poppverProps.trigger"
      :popperClass="legendMoreMap.poppverProps.popperClass"
    >
      <div slot="reference">
        <span>{{legendMoreMap.label}}</span>
        <i :class="configIcon"></i>
      </div>
      <div
        class="kye-report-echarts-legend-more-poppver-content"
        :style="legendMoreMap.poppverProps.popperClassContentStyle"
      >
        <el-input
          v-model="legendMoreMap.searchValue"
          :placeholder="legendMoreMap.placeholder"
          clearable
        ></el-input>
        <div class="kye-report-echarts-legend-more-poppver-content-tips">最多可选{{visibleLength}}项</div>
        <ul>
          <li
            v-for="(item, index) in legendVisibleData"
            :key="item.name"
            @click="handleClickLegendMoreItem(item, index)"
          >
            <span :class="{'checked': item.checked}">{{item.name}}</span>
            <i v-if="item.checked" class="el-icon-check checked"></i>
          </li>
        </ul>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    legendMoreMap: {
      type: Object,
      default: () => ({})
    },
    echartsInstance: Object
  },
  computed: {
    visibleLength () {
      const { visibleNum, visibleNames = [] } = this.legendMoreMap || {}
      const leng = visibleNames.length ? visibleNames.length : visibleNum
      return leng
    },
    configIcon () {
      return this.legendMoreMap.isOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    },
    legendMoreStyle () {
      const { right = 0, top = 0, width = 0 } = this.legendMoreMap || {}
      return {
        right: right + 'px',
        top: top + 'px',
        width: width + 'px'
      }
    },
    legendVisibleData () {
      const { searchValue, data } = this.legendMoreMap || {}
      return searchValue ? data.filter(e => e.name.indexOf(searchValue) > -1) : data
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.echartsInstance.on('legendselectchanged', params => {
        const { name, selected } = params
        const checked = selected[name]
        const index = this.legendMoreMap.data.findIndex(e => e.name === name)
        const max = this.visibleLength
        this.$set(this.legendMoreMap.data[index], 'checked', checked)
        if (this.legendMoreMap.data.filter(ele => ele.checked).length > max) {
          this.legendToggleSelect(name, !checked)
          this.$set(this.legendMoreMap.data[index], 'checked', !checked)
        } else {
          this.updateLegendData()
        }
      })
    })
  },
  methods: {
    updateLegendData () {
      if (!this.legendMoreMap.visibleCheckedData) {
        return
      }
      const checkedData = this.legendMoreMap.data.filter(ele => ele.checked)
      const data = checkedData.length ? checkedData : this.legendMoreMap.data.slice(0, 5)
      this.echartsInstance.setOption({
        legend: {
          data
        }
      })
    },
    showPoppver (val) {
      this.legendMoreMap.isOpen = !!val
    },
    legendToggleSelect (name, checked) {
      this.echartsInstance.dispatchAction({
        type: checked ? 'legendSelect' : 'legendUnSelect',
        // 图例名称
        name
      })
      this.updateLegendData()
    },
    handleClickLegendMoreItem (item, index) {
      const data = this.legendMoreMap.data
      const max = this.visibleLength
      if (data.filter(e => e.checked).length === max) {
        if (item.checked) {
          item.checked = false
        }
        this.legendToggleSelect(item.name, item.checked)
        return
      }
      item.checked = !item.checked
      this.legendToggleSelect(item.name, item.checked)
    },
  }
}
</script>

<style lang="less" scoped>
  .kye-report-echarts-legend-more {
    position: absolute;
    color: var(--g-color-primary);
    font-size: 12px;
    line-height: 14px;
    cursor: pointer;
    user-select: none;
  }
  .kye-report-echarts-legend-more-poppver {
    padding: 8px !important;
    &-content {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      &-tips {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        padding: 5.5px 0;
      }
      ul {
        flex: 1;
        overflow-y: auto;
        li {
          line-height: 18px;
          font-size: 12px;
          color: #ADADAD;
          padding: 5.5px 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          user-select: none;
          &:hover {
            background-color: #f3f6f9;
          }
          i,span {
            line-height: 18px;
            &.checked {
              color: var(--g-color-primary);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/components/legend-selected.vue